import {BRANDS_LOADING_STATES} from "@Libraries/brands-library";
import type {Brand, BrandContent, ContentStateForSingleBrandKit} from "@Components/mystuff-brands/brand-kits.types";
import {useAppSelector} from "@/hooks";
import type {RootState} from "@/store";

export const useHasContentForAllBrandKitsLoaded = (): boolean => {
    return useAppSelector(state => {
        return state.brands.brandsLoadingState === BRANDS_LOADING_STATES.LOADED && hasContentForAllBrandKitsLoaded(state);
    })
}

const hasContentForAllBrandKitsLoaded = (reduxState: RootState): boolean => {
    const {brands} = reduxState;
    for (let i = 0; i < brands.brands.length; i++) {
        const {brandId} = brands.brands[i] as Brand;
        const brandContent = (brands.brandContent as BrandContent)[brandId];
        if (!brandContent || isContentLoadingForSingleBrand(brandContent)) {
            return false;
        }
    }
    return true;

}

const isContentLoadingForSingleBrand = (contentStateForBrand: ContentStateForSingleBrandKit): boolean => {
    return contentStateForBrand.logos.loaded !== BRANDS_LOADING_STATES.LOADED && contentStateForBrand.colors.loaded !== BRANDS_LOADING_STATES.LOADED && contentStateForBrand.fonts.loaded !== BRANDS_LOADING_STATES.LOADED;
}